exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\nEssential imports for the global theme, but also to be used in single components\n**/\n.side-bar {\n  position: fixed;\n  min-height: 100vh;\n  width: 350px;\n  z-index: 1000;\n  background: #edeef0;\n  box-shadow: 0px 10px 20px #00000029;\n}", ""]);

// exports
